export default (arr, searchElement) => {
  if (!Array.isArray(arr)) {
    return false
  }
  return arr.indexOf(searchElement) !== -1
}
